import React from 'react';
import { RegionDropdown, CountryDropdown } from "react-country-region-selector";
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { storeAssigned } from '@/services/Methods/normalMethods';
import _ from 'lodash';

const DO_PROVINCES = [
    "Azua", "Bahoruco", "Barahona", "Dajabón", "Duarte", "Elías Piña", "El Seibo",
    "Espaillat", "Hato Mayor", "Hermanas Mirabal", "Independencia", "La Altagracia",
    "La Romana", "La Vega", "María Trinidad Sánchez", "Monseñor Nouel", "Monte Cristi",
    "Monte Plata", "Pedernales", "Peravia", "Puerto Plata", "Samaná", "San Cristóbal",
    "San José de Ocoa", "San Juan", "San Pedro de Macorís", "Sánchez Ramírez", "Santiago",
    "Santiago Rodríguez", "Santo Domingo", "Valverde", "Distrito Nacional"
];

const CountryAndStateInputs = ({ countryCodes, setCountryState, countryState, onChange }) => {
    const fieldValue = useFormikContext();
    return (
        <div className='w-full justify-between flex sm:flex-nowrap flex-wrap sm:gap-4 gap-6 xl:mb-[24px] mb-[24px] '>
            <div className='country_state_main flex flex-wrap sm:w-[calc(100%/2-8px)] w-full'>
                <div className={`select hide-country w-full `}>
                    <CountryDropdown
                        value={countryState?.country}
                        name="country"
                        valueType="short"
                        className="floating-input bg-[transparent] border-clr border-[1px] px-3.5 pt-4 pb-3 block w-full font-medium placeholder:text-black text-base rounded-[6px] h-[54px]"
                        whitelist={[_.upperCase(storeAssigned())]}
                        onChange={(val) => {
                            if (!val) {
                                setCountryState((prv) => ({ ...prv, country: val, countryError: "Please select the country" }));
                            }
                            else {
                                setCountryState((prv) => ({ ...prv, country: val, countryError: "" }));
                            }
                            onChange(val);
                        }} />
                    {fieldValue?.errors?.shipping_country && <p className='text-sm !text-red-500'>{fieldValue?.errors?.shipping_country}</p>}
                </div>
            </div>
            <div className='country_state_main flex flex-wrap sm:w-[calc(100%/2-8px)] w-full'>
                <div className={`select w-full `}>
                    {(storeAssigned()?.toUpperCase() || countryState?.country) === 'DO' ? (
                        <select
                            disabled={!countryState?.country}
                            value={countryState?.state || ""}
                            name="state"
                            className="floating-input bg-[transparent] border-clr border-[1px] px-3.5 pt-4 pb-3 block w-full font-medium placeholder:text-black text-base rounded-[6px] h-[54px]"
                            onChange={(e) => {
                                const val = e.target.value;
                                if (!val) {
                                    setCountryState((prv) => ({ ...prv, state: val, stateError: "Please select the state" }));
                                }
                                else {
                                    setCountryState((prv) => ({ ...prv, state: val, stateError: "" }));
                                }
                                onChange(val, 'state');
                            }}
                        >
                            <option value="">{countryState?.country === 'CA' ? 'Province' : "State"}</option>
                            {DO_PROVINCES.map((prov) => (
                                <option key={prov} value={prov}>{prov}</option>
                            ))}
                        </select>
                    ) : (
                        <RegionDropdown
                            country={storeAssigned()?.toUpperCase() || countryState?.country}
                            disabled={!countryState?.country}
                            value={countryState?.state}
                            name="state"
                            valueType="short"
                            defaultOptionLabel={countryState?.country === 'CA' ? 'Province' : "State"}
                            countryValueType="short"
                            className="floating-input bg-[transparent] border-clr border-[1px] px-3.5 pt-4 pb-3 block w-full font-medium placeholder:text-black text-base rounded-[6px] h-[54px]"
                            onChange={(val) => {
                                if (!val) {
                                    setCountryState((prv) => ({ ...prv, state: val, stateError: "Please select the state" }));
                                }
                                else {
                                    setCountryState((prv) => ({ ...prv, state: val, stateError: "" }));
                                }
                                onChange(val, 'state');
                            }}
                        />
                    )}
                    {fieldValue?.errors?.shipping_state && <p className='text-sm !text-red-500'>{fieldValue?.errors?.shipping_state}</p>}
                </div>
            </div>
        </div>
    )
}

CountryAndStateInputs.propTypes = {
    // countryCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
    countryState: PropTypes.shape({
        country: PropTypes.string,
        countryError: PropTypes.string,
        state: PropTypes.string,
        stateError: PropTypes.string
    }).isRequired,
    setCountryState: PropTypes.func.isRequired,
    onChange: PropTypes.func
};

export default CountryAndStateInputs;